import events from '@picsio/events';
import picsioConfig from '../../../../config';

export default function (userId, event, integrations = [], transportType) {
  if (!event) return false;

  const collectionEventTypes = events.getCollectionTypes(picsioConfig.eventsAppName);
  const subscribeAnyway = ['request.created'].includes(event.type);

  if (collectionEventTypes.includes(event.type)) {
    // List of users that decided to disable {transportType} transport (collection transports)
    const transportTypeDisabledFor = event[`${transportType}DisabledFor`] || [];
    if (transportTypeDisabledFor.includes(userId) && event.type && !subscribeAnyway) return true;
  } else if (!subscribeAnyway) {
    const transportSettings = integrations.find((item) => (
      transportType === 'push'
        ? item.type === 'socket' || item.type === 'push'
        : item.type === transportType
    ));
    if (!transportSettings || !Array.isArray(transportSettings.eventTypes)) return true;
    if (!transportSettings.eventTypes.includes(event.type)) return true;
  }

  return false;
}
